(function ($) {
    'use strict';
    $(function () {
        objectFitImages();

        if ($(window).scrollTop() > 0) {
            $('header').addClass('header--is-scrolled');
        } else {
            $('header').removeClass('header--is-scrolled');
        }

        $(window).scroll(function () {
            if ($(window).scrollTop() > 0) {
                $('header').addClass('header--is-scrolled');
            } else {
                $('header').removeClass('header--is-scrolled');
            }
        });

        $(document).on('click', '.done-gdpr-toggle-display', function (e) {
            $('.done-gdpr-alert-box-wrapper').removeClass('active');
        });

        if ($('.js-type').length) {
            var typewriter = new Typewriter('.js-type', {
                loop: false,
                cursor: ''
            });

            var str = $('.js-type')
                .parent()
                .data('title');
            typewriter.typeString(str).start();
        }

        $('.js-open-faq').on('click', function (e) {
            e.preventDefault();
            $(this)
                .find('.js-answer')
                .slideToggle();
            $(this).toggleClass('active');
        });

        $('.js-accordion-opener').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var $this = $(this);
            var $parent = $this.parent();
            $parent.find('.js-accordion-content').slideToggle('slow');
            $parent.toggleClass('active');
        });
    });
})(jQuery);
